import Vue from 'vue';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import store from '@adobe/edex/frontend/store';
import {
  authRequestInterceptor,
  actAsRequestInterceptor,
  newrelicResponseInterceptor,
} from '@adobe/edex/ui/shared/api/utils';

export const DEFAULT_SITE_ID = 'a5ac163e-67f5-4464-aad1-faac2d05dbea';
export const LOCALE_HEADER = 'x-locale';

const defaultHeaders = Object.freeze({
  Pragma: 'no-cache',
  'Cache-Control': 'no-cache',
  'x-api-key': process.env.NX_IMS_CLIENT_ID,
});

// TODO : duplicated in frontend and edex app

const localeRequestInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.request.use(async (req) => {
    req.headers[LOCALE_HEADER] = store.state.config.locale;
    return req;
  });
};

const handleErrorCodeMap = new Map<string, string>([
  ['EMPTY_BADGE_WHILE_GRADING', 'i18n.error.empty_badge_while_grading'],
  ['GRADING_NOT_ALLOWED', 'i18n.error.grading_not _allowed'],
]);

const toastedResponseInterceptor = (instance: AxiosInstance) => {
  instance.interceptors.response.use(null, (error) => {
    const errorCode = error?.response?.data?.details?.error?.code;
    if (handleErrorCodeMap.has(errorCode)) {
      Vue.toasted.error(Vue.prototype.$t(handleErrorCodeMap.get(errorCode)));
    } else if (!axios.isCancel(error) && error.config?.method !== 'get') {
      Vue.toasted.error(Vue.prototype.$t('i18n.Announcements.createError'));
    }
    return Promise.reject(error);
  });
};

const getApiInstance = ({
  config,
  interceptors,
}: {
  config?: AxiosRequestConfig;
  interceptors: ((instance: AxiosInstance) => void)[];
}) => {
  const instance = axios.create({
    timeout: 10000,
    baseURL: process.env.NX_V3_API_URL,
    withCredentials: true,
    headers: defaultHeaders,
    ...config,
  });
  interceptors.forEach((applyInterceptor) => applyInterceptor(instance));
  return instance;
};

export const v3 = getApiInstance({
  interceptors: [
    authRequestInterceptor,
    actAsRequestInterceptor,
    localeRequestInterceptor,
    newrelicResponseInterceptor,
    toastedResponseInterceptor,
  ],
});

export const v3StaticPage = getApiInstance({
  interceptors: [localeRequestInterceptor, newrelicResponseInterceptor, toastedResponseInterceptor],
});

export const v3Auth = getApiInstance({
  config: {
    validateStatus: null,
  },
  interceptors: [localeRequestInterceptor, newrelicResponseInterceptor],
});

window.addEventListener('unhandledrejection', async function (event) {
  if (axios.isCancel(event.reason)) {
    console.warn('Unhandled cancel', event.reason);
    event.preventDefault();
  }
});
